/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import textStyles from '../../foundations/textStyles'
import Input from './input'

export default {
    baseStyle: {
        field: {
            bg: 'stokkeCore.white',
            borderBottom: '2px solid',
            borderRadius: 0,
            borderColor: 'transparent',
            ...textStyles['Regular Medium']
        }
    },
    variants: {
        ...Input.variants,
        // used for country field which is read only
        locked: {
            field: {
                borderColor: 'stokkeFunctional.alertGreen',
                _disabled: {
                    opacity: 'initial'
                }
            },
            icon: {
                // match accepted icon variant
                color: 'stokkeFunctional.alertGreen',
                _disabled: {
                    opacity: null
                },
                mr: 2
            }
        },
        link: {
            field: {
                textStyles: 'Regular Medium',
                textDecoration: 'underline',
                textUnderlineOffset: 'var(--chakra-space-linkUnderlineOffset)',
                textAlign: 'right'
            }
        }
    },
    sizes: {
        md: {
            field: {
                height: 14,
                h: 14,
                px: 2,
                borderRadius: 'none',
                paddingInlineEnd: 6
            },
            icon: {
                fontSize: '1rem',
                right: 0,
                width: '1em'
            }
        }
    }
}
